import { AssetConfig, StakeMode } from "../../config/assets";
import { StakeFormShell } from "./StakeFormShell";
import { useRestakeSimple } from "./strategies/useRestakeSimple";
import { RestakeSolStrategy } from "./strategies/RestakeSolStrategy";
import { useUnstakeStandard } from "./strategies/useUnstakeStandard";

interface StakeStrategyContentProps {
  config: AssetConfig;
  mode: StakeMode;
  resetKey: string;
  vrtApy: number | null;
}

const RestakeSimpleStrategy = ({
  config,
  resetKey,
}: {
  config: AssetConfig;
  resetKey: string;
}) => {
  const { stakeFormProps } = useRestakeSimple({ config, resetKey });
  return <StakeFormShell {...stakeFormProps} />;
};

const UnstakeStrategy = ({
  config,
  resetKey,
  vrtApy,
}: {
  config: AssetConfig;
  resetKey: string;
  vrtApy: number | null;
}) => {
  const { stakeFormProps, belowForm } = useUnstakeStandard({ config, resetKey, vrtApy });
  return (
    <>
      <StakeFormShell {...stakeFormProps} />
      {belowForm}
    </>
  );
};

export const StakeStrategyContent = ({
  config,
  mode,
  resetKey,
  vrtApy,
}: StakeStrategyContentProps) => {
  if (mode === "unstake") {
    return <UnstakeStrategy config={config} resetKey={resetKey} vrtApy={vrtApy} />;
  }

  if (config.restakeStrategy === "sol") {
    return <RestakeSolStrategy config={config} resetKey={resetKey} />;
  }

  return <RestakeSimpleStrategy config={config} resetKey={resetKey} />;
};
